import { Injectable } from '@angular/core';
import {BehaviorSubject} from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class FloorService {
  selectedFloor: BehaviorSubject<number> = new BehaviorSubject<number>(1);

  constructor() { }

  setFloor(floor: number): void {
    if (this.selectedFloor.value !== floor) {
      this.selectedFloor.next(floor);
    }
  }
}
